// @flow
import React from "react";
import classnames from "classnames";
import ClientConfig from "../context/clientConfig";
import i18n from "../../i18n";

const Heading = () => (
  <ClientConfig.Consumer>
    {clientConfig => {
      const { headingText, headingClassNames, headingOrder, customNS } = clientConfig;
      const translatedText = i18n.t(headingText, {ns: customNS});
      if (headingText !== "") {
        return (
          <h1
            id='header_text'
            aria-label={translatedText} 
            className={classnames(headingClassNames, headingOrder)}
          >
            {translatedText}
          </h1>
        );
      } else {
        return <br />;
      }
    }}
  </ClientConfig.Consumer>
);
export default Heading;
